import { AxiosError } from 'axios';
import { t } from 'i18next';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import AsyncTable, { Column, RequestPage } from '../../../../components/AsyncTable';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../components/Notification';
import { ActionButtonsContainer } from '../../../../components/TablePaginator/styles';
import ViewLog from '../../../../components/ViewLog';
import HttpStatus from '../../../../enums/httpStatus';
import { ViewDetailsIcon } from '../../../../icons';
import {
  newCustomersApi as objReq,
  newCustomersTransactionApi as objReqTransactionLog
} from '../../../../services/requests';
import ContentContainter from '../../../../templates/Content/ContentContainer';
import { NewCustomerLogs as NewCusLogType } from '../../../../types/apiResponseTypes';

const NewCustomerLogsJSX = () => {
  const theme = useTheme();

  const [logs, setLogs] = useState<NewCusLogType[]>([]);

  const [infoLog, setInfoLog] = useState<any>(null);
  const [viewLog, setViewLog] = useState(false);

  const [updateTable] = useState(0);

  const handleGetInfoLog = async (row: NewCusLogType) => {
    const infoLog = await reqGetInfoLog(row);
    setInfoLog(infoLog);
    setViewLog(true);
  };

  const reqGetInfoLog = async (row: NewCusLogType) => {
    try {
      const source = objReq.axios.CancelToken.source();

      objReqTransactionLog.query = `?cn_CodigoCliente=${row.cn_CGCCPF}`;
      const res = await objReqTransactionLog.index(source.token);

      if (res.status !== HttpStatus.OK) {
        throw res;
      }
      return res.data.data;

    } catch (e) {
      frontendNotification({
        message: 'erro ao obter log detalhado',
        type: 'error'
      });
      return null;

    }
  };

  const actionsButtons = (row: NewCusLogType) => (
    <ActionButtonsContainer type={4}>
      <ViewDetailsIcon title={t('toViewLog')} onClick={() => handleGetInfoLog(row)} />
    </ActionButtonsContainer>
  );

  const columns: Column<NewCusLogType>[] = [
    {
      label: t('cgcCpf') as string,
      accessor: 'cn_CGCCPF',
    },
    {
      label: t('companyName') as string,
      accessor: 'cn_RazaoSocial',
    },
    {
      label: t('sellerCode') as string,
      accessor: 'cn_CodigoVendedor',
    },
    {
      label: t('dateTime') as string,
      accessor: 'created_at',
    },
    {
      label: t('erpExport') as string,
      accessor: 'cn_ExportadoErp',
      cellStyle: {
        textAlign: 'center',
      },
      headerCellStyle: {
        textAlign: 'center',
      },
    },
    {
      label: t('erpMsgm') as string,
      accessor: 'cn_ExportadoErpErroMsg',
    },
    {
      label: t('customerCodeErp') as string,
      accessor: 'cn_CodigoClienteErp',
    },
    {
      label: t('actions') as string,
      headerCellStyle: {
        textAlign: 'center',
      },
      Cell: actionsButtons,
    },
  ];

  const getLogs: RequestPage = async ({ search, page, quantityPerPage }) => {
    let hasMore = true;
    const source = objReq.axios.CancelToken.source();

    try {
      // eslint-disable-next-line max-len
      objReq.query = `?search=${search}&page=${page}&quantityPerPage=${quantityPerPage}`;
      const res = await objReq.index(source.token);

      if (res.status !== HttpStatus.OK) {
        throw res;
      }

      const { data }: { data: NewCusLogType[] } = res.data;

      if (data.length === 0) {
        hasMore = false;
      }

      return {
        data,
        hasMore,
        totalPage: 0,
      };
    } catch (err) {
      if (!objReq.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }

      return {
        data: [],
        hasMore: false,
        totalPage: 0,
      };
    }
  };

  return (
    <ContentContainter title={t('newCustomerLog')}>
      <AsyncTable
        tableName={t('importerLogs')}
        columns={columns}
        value={logs}
        onChange={setLogs}
        requestPage={getLogs}
        reqListener={[updateTable]}
        options={{
          styles: {
            primaryColor: `${theme.colors.surface}`,
            secondaryColor: `${theme.colors.onSurface}`,
            alternateRowColor: theme.colors.onSurfaceLight,
            textColor: theme.colors.text,
          },
          quantityPerPageLabel: t('quantityPerPage'),
          searchPlaceholder: t('search'),
        }}
      />

      {viewLog && (
        <ViewLog
          showModal={viewLog}
          closeModal={() => setViewLog(false)}
          log={JSON.stringify(infoLog, null, 2)}
        />
      )}

    </ContentContainter>
  );
};

export default NewCustomerLogsJSX;
